import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';

import {xsDown, xsUp} from '../../common/breakpoints';
import {cssIf} from '../../common/conditional-styles';
import Link from '../typography/link';
import Button from './button';

const Container = styled.div`
    text-align: center;
`;

const ButtonStrip = styled.div`
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;

    ${cssIf('scHasTertiary')`
        padding-bottom: 32px;
    `}

    ${xsDown`
        > *:not(:last-child) {
            // margin: 0 0 24px;
        }
    `}

    ${xsUp`
        flex-direction: row;

        > *:not(:last-child) {
            // margin: 0 24px 0 0;
        }
    `}
`;

// TODO: Move styling to Link itself or remove altogether (waiting on design decision)
const StyledLink = styled(Link)`
    text-decoration: underline;
`;

export default function Actions({
    className,
    primaryAction,
    secondaryAction,
    tertiaryAction,
}) {
    const primaryElement = !!primaryAction && (
        <Button
            isTall
            color="primary"
            href={primaryAction.href}
            onClick={primaryAction.onClick}
            disabled={primaryAction.isDisabled}
        >
            {primaryAction.label}
        </Button>
    );

    const secondaryElement = !!secondaryAction && (
        <Button
            isTall
            color="secondary"
            href={secondaryAction.href}
            onClick={secondaryAction.onClick}
            disabled={secondaryAction.isDisabled}
        >
            {secondaryAction.label}
        </Button>
    );

    const tertiaryElement = !!tertiaryAction && (
        <StyledLink
            href={tertiaryAction.href}
            onClick={tertiaryAction.onClick}
            disabled={tertiaryAction.isDisabled}
        >
            {tertiaryAction.label}
        </StyledLink>
    );

    return (
        <Container className={classnames('Actions', className)}>
            <ButtonStrip
                scHasSecondary={!!secondaryAction}
                scHasTertiary={!!tertiaryAction}
            >
                {secondaryElement}
                {primaryElement}
            </ButtonStrip>

            {/* Show the tertiary action last always as per the design system */}
            {tertiaryElement}
        </Container>
    );
}

Actions.propTypes = {
    className: propTypes.string,
    primaryAction: propTypes.shape({
        isDisabled: propTypes.bool,
        label: propTypes.string.isRequired,
        href: propTypes.string,
        onClick: propTypes.func,
    }),
    secondaryAction: propTypes.shape({
        isDisabled: propTypes.bool,
        label: propTypes.string.isRequired,
        href: propTypes.string,
        onClick: propTypes.func,
    }),
    tertiaryAction: propTypes.shape({
        isDisabled: propTypes.bool,
        label: propTypes.string.isRequired,
        href: propTypes.string,
        onClick: propTypes.func,
    }),
};
